import type { ThemeIcons } from '@deity/falcon-ui';
import {
  AccountTree,
  AccountTreeRounded,
  Add,
  ArrowBack,
  ArrowForward,
  ArrowForwardRounded,
  Ballot,
  Check,
  CheckCircleOutline,
  CheckCircleOutlined,
  ChevronRight,
  ChevronRightRounded,
  Clear,
  CloudDone,
  CloudDownloadRounded,
  CloudUpload,
  CloudUploadRounded,
  DashboardRounded,
  Delete,
  DeleteOutlineRounded,
  DoneAll,
  DoneRounded,
  DragIndicator,
  Edit,
  ErrorOutlineRounded,
  FileCopyOutlined,
  Help,
  HelpOutlineOutlined,
  History,
  Info,
  KeyboardArrowDown,
  Lock,
  LockOpen,
  LockOutlined,
  OpenInNew,
  OpenWith,
  PaletteRounded,
  PlayArrowRounded,
  PlayCircleOutline,
  PowerSettingsNew,
  RadioButtonChecked,
  RadioButtonUnchecked,
  ShuffleRounded,
  Stop,
  UnfoldLessRounded,
  UnfoldMore,
  UnfoldMoreRounded,
  WarningOutlined
} from '@mui/icons-material';

export const icons: ThemeIcons = {
  arrowBack: {
    icon: ArrowBack
  },
  unfold: {
    icon: UnfoldMore
  },
  info: {
    icon: Info
  },
  error: {
    icon: Info
  },
  success: {
    icon: CheckCircleOutline
  },
  warning: {
    icon: Info
  },
  close: {
    icon: Clear
  },
  clear: {
    icon: Clear
  },
  edit: {
    icon: Edit,
    size: 'lg'
  },
  delete: {
    icon: Delete
  },
  deleteOutline: {
    icon: DeleteOutlineRounded
  },
  add: {
    icon: Add,
    size: 'lg'
  },
  check: {
    icon: Check
  },
  chevronDown: {
    icon: KeyboardArrowDown
  },
  chevronRight: {
    icon: ChevronRight
  },
  circleOutline: {
    icon: RadioButtonUnchecked
  },
  circle: {
    icon: RadioButtonChecked
  },
  logout: {
    icon: PowerSettingsNew
  },
  lock: {
    icon: Lock
  },
  lockOpen: {
    icon: LockOpen
  },

  dashboard: {
    icon: DashboardRounded
  },

  lockOutlined: {
    icon: LockOutlined
  },
  arrowForward: {
    icon: ArrowForward
  },
  cloudDone: {
    icon: CloudDone
  },
  cloudUpload: {
    icon: CloudUpload
  },
  stop: {
    icon: Stop
  },
  openWith: {
    icon: OpenWith
  },
  ballot: {
    icon: Ballot
  },
  accountTree: {
    icon: AccountTree
  },
  playCircle: {
    icon: PlayCircleOutline
  },
  chevronRightRounded: {
    icon: ChevronRightRounded
  },
  doneAll: {
    icon: DoneAll
  },
  fileCopyOutlined: {
    icon: FileCopyOutlined
  },
  accountTreeRounded: {
    icon: AccountTreeRounded
  },
  unfoldMoreRounded: {
    icon: UnfoldMoreRounded
  },
  unfoldLessRounded: {
    icon: UnfoldLessRounded
  },
  checkCircle: {
    icon: CheckCircleOutlined
  },
  help: {
    icon: Help
  },
  helpOutline: {
    icon: HelpOutlineOutlined
  },
  upload: {
    icon: CloudUploadRounded
  },
  download: {
    icon: CloudDownloadRounded
  },
  history: {
    icon: History
  },
  dragIndicator: {
    icon: DragIndicator
  },
  paletteRounded: {
    icon: PaletteRounded
  },
  arrowForwardRounded: {
    icon: ArrowForwardRounded
  },
  shuffle: {
    icon: ShuffleRounded
  },
  errorOutlineRounded: {
    icon: ErrorOutlineRounded
  },
  warningOutlined: {
    icon: WarningOutlined
  },
  doneRounded: {
    icon: DoneRounded
  },
  play: {
    icon: PlayArrowRounded
  },
  api: {
    icon: (props: any) => (
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="none" {...props}>
        <g>
          <rect fill="none" height="24" width="24" />
          <path d="M14,12l-2,2l-2-2l2-2L14,12z M12,6l2.12,2.12l2.5-2.5L12,1L7.38,5.62l2.5,2.5L12,6z M6,12l2.12-2.12l-2.5-2.5L1,12 l4.62,4.62l2.5-2.5L6,12z M18,12l-2.12,2.12l2.5,2.5L23,12l-4.62-4.62l-2.5,2.5L18,12z M12,18l-2.12-2.12l-2.5,2.5L12,23l4.62-4.62 l-2.5-2.5L12,18z" />
        </g>
      </svg>
    )
  },
  date: {
    icon: (props: any) => (
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="none" {...props}>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z" />
      </svg>
    )
  },
  text: {
    icon: (props: any) => (
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="none" {...props}>
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M21 11.01L3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z" />
      </svg>
    )
  },
  boolean: {
    icon: (props: any) => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 24 24"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="none"
        {...props}
      >
        <g>
          <rect fill="none" height="24" width="24" />
          <path d="M16.54,11L13,7.46l1.41-1.41l2.12,2.12l4.24-4.24l1.41,1.41L16.54,11z M11,7H2v2h9V7z M21,13.41L19.59,12L17,14.59 L14.41,12L13,13.41L15.59,16L13,18.59L14.41,20L17,17.41L19.59,20L21,18.59L18.41,16L21,13.41z M11,15H2v2h9V15z" />
        </g>
      </svg>
    )
  },
  dict: {
    icon: (props: any) => (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M0 0.375V3L3 0H0.375C0.165 0 0 0.165 0 0.375ZM9 0L12 3V0.375C12 0.165 11.835 0 11.625 0H9ZM12 11.625V9L9 12H11.625C11.835 12 12 11.835 12 11.625ZM0.375 12H3L0 9V11.625C0 11.835 0.165 12 0.375 12ZM11.25 6C11.25 3.0975 8.9025 0.75 6 0.75C3.0975 0.75 0.75 3.0975 0.75 6C0.75 8.9025 3.0975 11.25 6 11.25C8.9025 11.25 11.25 8.9025 11.25 6ZM6 9.75C3.93 9.75 2.25 8.07 2.25 6C2.25 3.93 3.93 2.25 6 2.25C8.07 2.25 9.75 3.93 9.75 6C9.75 8.07 8.07 9.75 6 9.75Z" />
      </svg>
    )
  },
  list: {
    icon: (props: any) => (
      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M12.25 3H1.75C0.925 3 0.25 2.325 0.25 1.5C0.25 0.675 0.925 0 1.75 0H12.25C13.075 0 13.75 0.675 13.75 1.5C13.75 2.325 13.075 3 12.25 3ZM12.25 4.5H1.75C0.925 4.5 0.25 5.175 0.25 6C0.25 6.825 0.925 7.5 1.75 7.5H12.25C13.075 7.5 13.75 6.825 13.75 6C13.75 5.175 13.075 4.5 12.25 4.5ZM12.25 9H1.75C0.925 9 0.25 9.675 0.25 10.5C0.25 11.325 0.925 12 1.75 12H12.25C13.075 12 13.75 11.325 13.75 10.5C13.75 9.675 13.075 9 12.25 9Z" />
      </svg>
    )
  },
  int: {
    icon: (props: any) => (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M6.75 5.25C6.3375 5.25 6 5.5875 6 6V8.25H3.75C3.3375 8.25 3 8.5875 3 9C3 9.4125 3.3375 9.75 3.75 9.75H6V12C6 12.4125 6.3375 12.75 6.75 12.75C7.1625 12.75 7.5 12.4125 7.5 12V9.75H9.75C10.1625 9.75 10.5 9.4125 10.5 9C10.5 8.5875 10.1625 8.25 9.75 8.25H7.5V6C7.5 5.5875 7.1625 5.25 6.75 5.25ZM15 13.5H13.5V5.535L11.25 6.3V5.025L14.775 3.75H15V13.5Z" />
      </svg>
    )
  },
  string: {
    icon: (props: any) => (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M7.4475 10.125H10.5525L9 5.985L7.4475 10.125ZM15 1.5H3C2.175 1.5 1.5 2.175 1.5 3V15C1.5 15.825 2.175 16.5 3 16.5H15C15.825 16.5 16.5 15.825 16.5 15V3C16.5 2.175 15.825 1.5 15 1.5ZM11.7825 13.41L11.1075 11.625H6.8775L6.21 13.4025C6.105 13.6875 5.835 13.875 5.5275 13.875C5.0175 13.875 4.665 13.3575 4.8525 12.885L8.04 4.7775C8.205 4.38 8.58 4.125 9 4.125C9.42 4.125 9.795 4.38 9.9525 4.7775L13.14 12.885C13.3275 13.3575 12.975 13.875 12.465 13.875C12.165 13.875 11.895 13.6875 11.7825 13.41Z" />
      </svg>
    )
  },
  decimal: {
    icon: (props: any) => (
      <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M4.4353 0.818182V11H2.89411V2.35938H2.83445L0.398367 3.95028V2.47869L2.93885 0.818182H4.4353ZM9.09393 11.0945C8.82215 11.0945 8.58848 10.9983 8.39293 10.8061C8.19738 10.6106 8.09961 10.3752 8.09961 10.1001C8.09961 9.82836 8.19738 9.59635 8.39293 9.40412C8.58848 9.20857 8.82215 9.1108 9.09393 9.1108C9.36571 9.1108 9.59937 9.20857 9.79492 9.40412C9.99047 9.59635 10.0882 9.82836 10.0882 10.1001C10.0882 10.2824 10.0418 10.4498 9.94904 10.6023C9.85955 10.7514 9.74023 10.8707 9.59109 10.9602C9.44194 11.0497 9.27622 11.0945 9.09393 11.0945ZM12.8005 11V9.88636L16.2458 6.31676C16.6137 5.92898 16.917 5.58925 17.1556 5.29759C17.3976 5.0026 17.5782 4.72254 17.6975 4.45739C17.8168 4.19223 17.8765 3.91051 17.8765 3.61222C17.8765 3.27415 17.7969 2.98248 17.6379 2.73722C17.4788 2.48864 17.2617 2.29806 16.9866 2.16548C16.7115 2.02959 16.4016 1.96165 16.0569 1.96165C15.6923 1.96165 15.3741 2.03622 15.1023 2.18537C14.8306 2.33452 14.6218 2.54498 14.4759 2.81676C14.3301 3.08854 14.2572 3.40672 14.2572 3.77131H12.7906C12.7906 3.15151 12.9331 2.60961 13.2181 2.1456C13.5031 1.68158 13.8942 1.32197 14.3914 1.06676C14.8886 0.808238 15.4537 0.678977 16.0867 0.678977C16.7264 0.678977 17.2898 0.806581 17.7771 1.06179C18.2676 1.31368 18.6504 1.65838 18.9255 2.09588C19.2006 2.53007 19.3381 3.0206 19.3381 3.56747C19.3381 3.94531 19.2669 4.31487 19.1244 4.67614C18.9852 5.0374 18.7415 5.4401 18.3935 5.88423C18.0455 6.32505 17.5616 6.86032 16.9418 7.49006L14.9184 9.60795V9.68253H19.5022V11H12.8005Z" />
      </svg>
    )
  },
  arrowLeftPolygon: {
    icon: (props: any) => (
      <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M1.5 9.40193C-0.500003 10.5566 -0.5 13.4434 1.5 14.5981L16.5 23.2583C18.5 24.413 21 22.9697 21 20.6603V3.33974C21 1.03034 18.5 -0.413031 16.5 0.74167L1.5 9.40193Z" />
      </svg>
    )
  },
  google: {
    icon: (props: any) => (
      <svg viewBox="0 0 35 35" {...props}>
        <path
          fill="#ea4335"
          d="M18.193,6.927a9.512,9.512,0,0,1,6.716,2.625L29.9,4.557A16.834,16.834,0,0,0,18.193,0,17.491,17.491,0,0,0,2.56,9.64l5.819,4.514A10.447,10.447,0,0,1,18.193,6.927Z"
          transform="translate(-0.693)"
        />
        <path
          fill="#4285f4"
          d="M40.756,23.318A21.286,21.286,0,0,0,40.479,20H24v6.577h9.435a8.134,8.134,0,0,1-3.485,5.235l5.636,4.375a17.151,17.151,0,0,0,5.17-12.87Z"
          transform="translate(-6.5 -5.417)"
        />
        <path
          fill="#fbbc05"
          d="M7.678,24.427a10.63,10.63,0,0,1-.554-3.347,10.426,10.426,0,0,1,.554-3.347L1.859,13.22a17.514,17.514,0,0,0,.007,15.721l5.811-4.514Z"
          transform="translate(0 -3.58)"
        />
        <path
          fill="#34a853"
          d="M18.191,42.74A16.654,16.654,0,0,0,29.777,38.5l-5.636-4.375A10.6,10.6,0,0,1,8.369,28.58L2.55,33.094A17.5,17.5,0,0,0,18.191,42.74Z"
          transform="translate(-0.691 -7.74)"
        />
        <path fill="none" d="M0,0H35V35H0Z" />
      </svg>
    ),
    size: 'sm'
  },
  microsoft: {
    icon: (props: any) => (
      <svg viewBox="0 0 512 512" {...props}>
        <path fill="#4CAF50" d="M272,240h240V16c0-8.832-7.168-16-16-16H272V240z" />
        <path fill="#F44336" d="M240,240V0H16C7.168,0,0,7.168,0,16v224H240z" />
        <path fill="#2196F3" d="M240,272H0v224c0,8.832,7.168,16,16,16h224V272z" />
        <path fill="#FFC107" d="M272,272v240h224c8.832,0,16-7.168,16-16V272H272z" />
      </svg>
    ),
    size: 'sm'
  },
  github: {
    icon: (props: any) => (
      <svg viewBox="0 0 34.663 33.808" {...props}>
        <path
          fill="1b1f23"
          fillRule="evenodd"
          d="M17.332,0a17.332,17.332,0,0,0-5.481,33.775c.867.152,1.192-.368,1.192-.823,0-.412-.022-1.776-.022-3.228-4.355.8-5.481-1.062-5.828-2.036a6.3,6.3,0,0,0-1.776-2.448c-.607-.325-1.473-1.127-.022-1.148a3.468,3.468,0,0,1,2.665,1.776,3.7,3.7,0,0,0,5.048,1.43,3.646,3.646,0,0,1,1.1-2.318c-3.856-.433-7.886-1.928-7.886-8.558A6.745,6.745,0,0,1,8.1,11.764a6.228,6.228,0,0,1,.173-4.593s1.452-.455,4.766,1.776a16.34,16.34,0,0,1,8.666,0c3.315-2.253,4.766-1.776,4.766-1.776a6.228,6.228,0,0,1,.173,4.593,6.706,6.706,0,0,1,1.776,4.658c0,6.651-4.051,8.124-7.908,8.558a4.1,4.1,0,0,1,1.17,3.206c0,2.318-.022,4.181-.022,4.766,0,.455.325,1,1.192.823A17.341,17.341,0,0,0,17.332,0Z"
        />
      </svg>
    ),
    size: 'sm'
  },
  bitbucket: {
    icon: (props: any) => (
      <svg viewBox="0 0 36.114 32.474" {...props}>
        <defs>
          <style>{'.a{fill:none;}.b{fill:#2684ff;}.c{fill:url(#a);}'}</style>
          <linearGradient id="a" x1="1.086" y1="0.138" x2="0.469" y2="0.788" gradientUnits="objectBoundingBox">
            <stop offset="0.18" stopColor="#0052cc" />
            <stop offset="1" stopColor="#2684ff" />
          </linearGradient>
        </defs>
        <g transform="translate(0 0.001)">
          <path className="a" d="M89.065,87.866H96.6l1.82-10.625H87.06Z" transform="translate(-74.779 -66.345)" />
          <path
            className="b"
            d="M1.172,0A1.157,1.157,0,0,0,.015,1.342L4.927,31.16a1.574,1.574,0,0,0,1.539,1.313H30.03a1.157,1.157,0,0,0,1.157-.972L36.1,1.348A1.157,1.157,0,0,0,34.941.005ZM21.855,21.55H14.334L12.3,10.911h11.38Z"
            transform="translate(0 0)"
          />
          <path
            className="c"
            d="M67.671,77.242H56.821L55,87.873H47.484L38.611,98.406a1.567,1.567,0,0,0,1.012.381H63.174a1.156,1.156,0,0,0,1.156-.971Z"
            transform="translate(-33.164 -66.346)"
          />
        </g>
      </svg>
    ),
    size: 'sm'
  },
  auth0: {
    icon: (props: any) => (
      <svg viewBox="0 0 256 287" {...props}>
        <path
          d="M203.24 231.531l-28.73-88.434l75.208-54.64h-92.966L128.019.025l-.009-.024h92.98l28.74 88.446l.002-.002l.024-.013c16.69 51.31-.5 109.67-46.516 143.098zm-150.45 0l-.023.017l75.228 54.655l75.245-54.67l-75.221-54.656l-75.228 54.654zM6.295 88.434c-17.57 54.088 2.825 111.4 46.481 143.108l.007-.028l28.735-88.429l-75.192-54.63h92.944L128.004.024L128.01 0H35.025L6.294 88.434z"
          fill="#EB5424"
        />
      </svg>
    ),
    size: 'sm'
  },
  logo: {
    icon: (props: any) => (
      <svg viewBox="0 0 162 64" {...props}>
        <g id="branding-/-logo-/-primary" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="branding-/-icon-/-primary" fill="#A0CC3F">
            <path
              d="M32,0 L39.58,4.332 L39.5803807,16.5261841 L32.0612341,12.2982533 L14.9769148,22.0721748 L14.9769148,41.6200179 L32.0561191,51.3939394 L49.1455534,41.6200179 L49.145,9.798 L60,16 L60,48 L32,64 L4,48 L4,16 L32,0 Z M32.1811377,23.3939394 L39.5930308,27.6060606 L39.5930308,36.030303 L32.186267,40.2424242 L24.7743739,36.030303 L24.7743739,27.6060606 L32.1811377,23.3939394 Z"
              id="logo-mark"
            />
          </g>
          <g id="branding-/-logotype-/-primary" transform="translate(70.000000, 22.000000)" fill="#100F15">
            <g id="DEITY-2">
              <path
                d="M8.88308033,3.17811912e-14 C15.4937448,-0.0291084067 19.4778506,4.20612156 19.4778506,9.97074014 C19.4778506,15.7941813 15.139602,20 8.88308033,20 L0,20 L0,0.0297142318 L8.88308033,3.17811912e-14 Z M4.83995074,4.47082344 L4.83995074,15.5294795 L8.88308033,15.5294795 C12.2474363,15.5294795 14.578876,13.3236305 14.578876,9.97074014 C14.578876,6.38255919 12.3064601,4.47082344 8.88308033,4.47082344 L4.83995074,4.47082344 Z M22.1958009,0.000302912527 L37.571498,0.000302912527 L37.571498,4.47082344 L27.0357516,4.47082344 L27.0357516,7.91194779 L35.8302963,7.91194779 L35.8302963,12.0883551 L27.0357516,12.0883551 L27.0357516,15.5294795 L37.571498,15.5294795 L37.571498,20 L22.1958009,20 L22.1958009,0.000302912527 Z M45.9557322,0.000302912527 L45.9557322,20 L41.1157814,20 L41.1157814,0.000302912527 L45.9557322,0.000302912527 Z M68.0039736,0.000302912527 L68.0039736,4.47082344 L60.8916069,4.47082344 L60.8916069,20 L55.9926324,20 L55.9926324,4.47082344 L48.8802657,4.47082344 L48.8802657,0.000302912527 L68.0039736,0.000302912527 Z M92,0.000302912527 L83.3825267,12.441291 L83.3825267,20 L78.5130641,20 L78.5130641,12.441291 L69.9546146,0.000302912527 L75.5323627,0.000302912527 L80.9920632,8.17664966 L86.3632281,0.000302912527 L92,0.000302912527 Z"
                id="DEITY"
              />
            </g>
          </g>
        </g>
      </svg>
    ),
    size: 'sm'
  },
  logoWhite: {
    icon: (props: any) => (
      <svg viewBox="0 0 162 64" {...props}>
        <g id="branding-/-logo-/-primary" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="branding-/-icon-/-primary" fill="#A0CC3F">
            <path
              d="M32,0 L39.58,4.332 L39.5803807,16.5261841 L32.0612341,12.2982533 L14.9769148,22.0721748 L14.9769148,41.6200179 L32.0561191,51.3939394 L49.1455534,41.6200179 L49.145,9.798 L60,16 L60,48 L32,64 L4,48 L4,16 L32,0 Z M32.1811377,23.3939394 L39.5930308,27.6060606 L39.5930308,36.030303 L32.186267,40.2424242 L24.7743739,36.030303 L24.7743739,27.6060606 L32.1811377,23.3939394 Z"
              id="logo-mark"
            />
          </g>
          <g id="branding-/-logotype-/-primary" transform="translate(70.000000, 22.000000)" fill="#FFFFFF">
            <g id="DEITY-2">
              <path
                d="M8.88308033,3.17811912e-14 C15.4937448,-0.0291084067 19.4778506,4.20612156 19.4778506,9.97074014 C19.4778506,15.7941813 15.139602,20 8.88308033,20 L0,20 L0,0.0297142318 L8.88308033,3.17811912e-14 Z M4.83995074,4.47082344 L4.83995074,15.5294795 L8.88308033,15.5294795 C12.2474363,15.5294795 14.578876,13.3236305 14.578876,9.97074014 C14.578876,6.38255919 12.3064601,4.47082344 8.88308033,4.47082344 L4.83995074,4.47082344 Z M22.1958009,0.000302912527 L37.571498,0.000302912527 L37.571498,4.47082344 L27.0357516,4.47082344 L27.0357516,7.91194779 L35.8302963,7.91194779 L35.8302963,12.0883551 L27.0357516,12.0883551 L27.0357516,15.5294795 L37.571498,15.5294795 L37.571498,20 L22.1958009,20 L22.1958009,0.000302912527 Z M45.9557322,0.000302912527 L45.9557322,20 L41.1157814,20 L41.1157814,0.000302912527 L45.9557322,0.000302912527 Z M68.0039736,0.000302912527 L68.0039736,4.47082344 L60.8916069,4.47082344 L60.8916069,20 L55.9926324,20 L55.9926324,4.47082344 L48.8802657,4.47082344 L48.8802657,0.000302912527 L68.0039736,0.000302912527 Z M92,0.000302912527 L83.3825267,12.441291 L83.3825267,20 L78.5130641,20 L78.5130641,12.441291 L69.9546146,0.000302912527 L75.5323627,0.000302912527 L80.9920632,8.17664966 L86.3632281,0.000302912527 L92,0.000302912527 Z"
                id="DEITY"
              />
            </g>
          </g>
        </g>
      </svg>
    ),
    size: 'sm'
  },
  loader: {
    icon: (props: any) => (
      <svg viewBox="0 0 50 50" {...props}>
        <path
          d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
          transform="rotate(241.969 25 25)"
        >
          <animateTransform
            attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="0.8s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    )
  },
  chevron: {
    icon: (props: any) => (
      <svg viewBox="0 0 24 24" {...props}>
        <path fill="none" d="M0,0H24V24H0Z" />
        <path d="M7,10l5,5,5-5Z" />
      </svg>
    )
  },
  checkboxCheckmarkIcon: {
    icon: Check
  },
  openInNew: {
    icon: OpenInNew
  }
};
